import { DrawerModal } from '@/components/utilities/DrawerModal'
import { useRouter } from 'next/router'
import querystring from 'querystring'
import { ListRowItem } from '../utilities/ListRowItem'

interface SortModalProps {
  toggleSort: () => void
  activeSort: string
  onRefetch: (sortVar: string) => void
  hasTabBar: boolean
}

export const SortModal = ({ toggleSort, activeSort, onRefetch, hasTabBar }: SortModalProps) => {
  const router = useRouter()

  const sorts = [
    {
      id: '000',
      title: 'Relevant',
      slug: 'relevant',
    },
    {
      id: '001',
      title: 'New Product',
      slug: 'new-product',
    },
    {
      id: '002',
      title: 'Most Popular',
      slug: 'most-selling',
    },
    {
      id: '003',
      title: 'Lowest Price',
      slug: 'lowest-price',
    },
    {
      id: '004',
      title: 'Highest Price',
      slug: 'highest-price',
    },
  ]

  return (
    <DrawerModal title='Sort By' handleClose={toggleSort} hasTabBar={hasTabBar}>
      {sorts.map(({ id, title, slug }) => {
        const handler = async () => {
          const currentUrl = window.location.pathname
          const currentQueries = window.location.search.replace('?', '')
          const parsedQueries = querystring.decode(currentQueries)
          const newQueries = { ...parsedQueries, sort: slug }
          const newParsedQueries = querystring.encode(newQueries)
          let newUrl = `${currentUrl}?${newParsedQueries}`
          toggleSort()
          await router.replace(newUrl).then(() => {
            onRefetch(slug)
          })
        }

        return <ListRowItem key={id} title={title} onClick={handler} active={slug === activeSort} />
      })}
    </DrawerModal>
  )
}
